export default {"src":"/_next/static/media/0x355c665e101b9da58704a8fddb5feef210ef20c0.669f6e99.svg","height":187,"width":183,"blurWidth":0,"blurHeight":0};